<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
      clearable

      :chips="multiple"
      :multiple="multiple"
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemOrderKind} from "@/modules/redactor/models/item-order/ItemOrderKind";

export default {
  name: "r-item-order-kind",
  props: {
    model: VueTypes.instanceOf(ItemOrderKind),
    models: VueTypes.arrayOf(ItemOrderKind),
    label: VueTypes.string.def("Kind:"),
    multiple: VueTypes.bool.def(false),
  },
  data: () => ({
    values: []
  }),
  computed: {
    value: {
      get: function () {
        if (this.multiple) {
          return this.models;
        } else {
          return this.model;
        }
      },
      set: function (value) {
        if (this.multiple) {
          this.$emit("update:models", value);
        } else {
          this.$emit("update:model", value);
        }
      }
    },
  },
  created() {
    this.values = ItemOrderKind.getValues();
  }
}
</script>